<!--
 * @Description:全局导出组件
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-09 10:39:33
 * @LastEditors: cxh
-->
<template>
  <a-button v-bind="$attrs" @click="exportFile" :loading="loading">{{ t('btn.export') }}</a-button>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { exportList } from '@/api/common'
import { DcMessage } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const loading = ref(false)
const props = defineProps({
  text: {
    type: String,
    default: '导出'
  },
  search: {
    type: Object,
    default: () => {
      return {}
    }
  },
  totalCount: {
    type: Number,
    default: 0
  },
  appId: {
    type: String
  },
  taskType: {
    type: String
  }
})
const exportFile = () => {
  if (props.totalCount > 15000) {
    DcMessage.warning('请一次导出1万5千条以下数据')
    return
  }
  loading.value = true
  const { pageNumber, pageSize, ...other } = props.search
  exportList({
    appId: props.appId,
    taskType: props.taskType,
    query: other
  })
    .then((res) => {
      DcMessage.success(t('tips.exportSuccess'))
    })
    .finally(() => {
      loading.value = false
    })
}
</script>
<script lang="ts">
export default {
  name: 'ExportBtn'
}
</script>
